import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function StaffRunOfShow() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/run-of-show").then(r => setRows(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="staff-run-of-show" className="space-y-6">
      <div>
        <div className="overline text-[var(--brand-primary)]">Run of Show</div>
        <h2 className="font-serif-cg text-3xl md:text-4xl tracking-tight mt-2">Minuto a minuto interno</h2>
      </div>

      {loading ? (
        <p className="text-[var(--brand-muted)]">Cargando...</p>
      ) : (
        <div className="card-cg overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[var(--brand-surface-alt)] text-left">
              <tr className="overline text-[var(--brand-muted)]">
                <th className="p-3 md:p-4">Hora</th>
                <th className="p-3 md:p-4">Actividad</th>
                <th className="p-3 md:p-4">Responsable</th>
                <th className="p-3 md:p-4">Área</th>
                <th className="p-3 md:p-4">Estado</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, idx) => (
                <tr key={r.id} data-testid={`ros-row-${idx}`} className={idx % 2 ? "bg-[var(--brand-surface-alt)]/50" : ""}>
                  <td className="p-3 md:p-4 font-serif-cg text-base text-[var(--brand-primary)] whitespace-nowrap">{r.time}</td>
                  <td className="p-3 md:p-4">{r.activity}</td>
                  <td className="p-3 md:p-4 text-[var(--brand-ink)]/80">{r.responsible}</td>
                  <td className="p-3 md:p-4 text-[var(--brand-ink)]/80">{r.area}</td>
                  <td className="p-3 md:p-4"><span className="text-[11px] px-2 py-1 bg-stone-100 text-stone-700">{r.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
